import { useEffect } from 'react';
import { useMemoizedFn } from 'ahooks';

/**
 * 锚点元素完全离开视口时触发回调（用于预览态三点菜单及其子 Popover 随卡片滚出屏幕后自动关闭）
 */
export function useClosePopoversWhenAnchorHidden(
  anchorEl: HTMLElement | null,
  shouldWatch: boolean,
  onHidden: () => void,
): void {
  const handleHidden = useMemoizedFn(onHidden);

  useEffect(() => {
    if (!shouldWatch) {
      return undefined;
    }

    if (!anchorEl) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry && !entry.isIntersecting) {
          handleHidden();
        }
      },
      { threshold: 0 },
    );

    observer.observe(anchorEl);
    return () => observer.disconnect();
  }, [shouldWatch, anchorEl, handleHidden]);
}
